import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import "./PrescriptionModal.css";
import dateFormat from "dateformat";
import axiosInstance from "../../api/axiosInstance";
import { apiurl } from "../../App";
import { Spin } from "antd";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="Close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon className="pres_closeicon" />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

class PerscriptionModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      prescriptionData: [],
      totalAmt: null,
      isLoading: false,
      prescriptionId: 0,
      order_label:""
    };
  }

  componentDidMount() {
    if (this.props.prescriptionId) {
      this.viewOrderPrescription();
    }
  }

  componentWillUpdate() {
    if (
      this.props.prescriptionId &&
      this.props.prescriptionId !== this.state.prescriptionId
    ) {
      this.setState({ prescriptionId: this.props.prescriptionId }, () => {
        this.viewOrderPrescription();
      });
    }
  }

  viewOrderPrescription = () => {
    this.setState({ isLoading: true, prescriptionData: [] });
    axiosInstance({
      method: "POST",
      url: apiurl + "pharmacy/viewOrderPrescription",
      data: {
        prescription_id: this.props.prescriptionId,
        pharmacy_id: this.props.pharmacyId,
      },
    })
      .then((response) => {
        // get kwd total
        var totalAmt = 0;
        if (response.data.data[0].medicines) {
          for (var i in response.data.data[0].medicines) {
            if (response.data.data[0].medicines[i].is_active == 1) {
              totalAmt =
                response.data.data[0].medicines[i].amount != null &&
                response.data.data[0].medicines[i].amount + totalAmt;
            }
          }
        }
        if(this.props.isFrom=="cancelledDashboard")
        {
          this.setState({order_label:"ID"})
        }
        else
        {
          this.setState({order_label:"Order ID"})
        }
        var total_data= response.data.data;
        if(this.props.isFrom=="revenueTable" && total_data.length!=0 )
        {
         var medicines_data = total_data[0].medicines.filter((obj)=>obj.is_active!=0)
          total_data[0].medicines=medicines_data;
        }
        this.setState({
          isLoading: false,
          prescriptionData: total_data,
          totalAmt: totalAmt,
        });
      })
      .catch((error) => {
        this.setState({
          isLoading: false,
          prescriptionData: [],
          totalAmt: 0,
        });
        console.log(error);
      });
  };

  handeClose = () => {
    this.setState({ prescriptionId: 0, prescriptionData: [] }, () => {
      this.props.onClose();
    });
  };

  render() {
    const { prescriptionData } = this.state;
    return (
      <div className="pharmacy_modaldiv">
        <Dialog
          className="Dialogmodal_pharmacy"
          onClose={this.handeClose}
          aria-labelledby="customized-dialog-title"
          open={this.props.open}
          maxWidth={this.props.xswidth ? "xs" : "md"}
          fullWidth={true}
          disableBackdropClick={true}
        >
          <DialogTitle
            id="customized-dialog-title"
            className="Modaltiltle_pharmacy"
            onClose={this.handeClose}
          >
            <Spin className="spinner_align" spinning={this.state.isLoading}>
              {prescriptionData.length > 0 && (
                <>
                  <div className="pers_head_div">
                    <h1 className="prescrip_head">Prescription</h1>
                  </div>

                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        marginLeft: "2%",
                        marginTop: "1%",
                        display: "flex",
                      }}
                    >
                      <p className="pres_labpersondet" style={{ width: "10%" }}>
                        Member Name 
                      </p>
                      &nbsp;:&nbsp;
                      <p className="pres_time">
                        {prescriptionData[0].customer}
                      </p>
                    </div>
                    <div
                      style={{
                        marginLeft: "2%",
                        marginTop: "1%",
                        display: "flex",
                      }}
                    >
                      <p className="pres_labpersondet" style={{ width: "10%" }}>
                        Doctor Name
                      </p>
                      &nbsp;:&nbsp;
                      <p className="pres_time">
                        {prescriptionData[0].doctor_name}
                      </p>
                    </div>
                    <div
                      style={{
                        marginLeft: "2%",
                        marginTop: "1%",
                        display: "flex",
                      }}
                    >
                      <p className="pres_labpersondet" style={{ width: "10%" }}>
                        Date
                      </p>
                      &nbsp;:&nbsp;
                      <p className="pres_time">
                        {dateFormat(
                          prescriptionData[0].prescript_date,
                          "dd-mmm-yy"
                        )}
                      </p>
                    </div>
                    <div
                      style={{
                        marginLeft: "2%",
                        marginTop: "1%",
                        display: "flex",
                      }}
                    >
                      <p className="pres_labpersondet" style={{ width: "10%" }}>
                         {this.state.order_label}
                      </p>
                      &nbsp;:&nbsp;
                      <p className="pres_time">{prescriptionData[0].orderid || ''}</p>
                    </div>
                  </div>
                </>
              )}
            </Spin>
          </DialogTitle>
          <DialogContent dividers className="DialogContent prescription-modal">
            <div
              style={{
                minHeight: "auto",
                maxHeight: "calc(100vh - 300px)",
                overflowY: "scroll",
              }}
            >
              {this.state.prescriptionData.length > 0 && (
                <table className="table table-borderless prescriptionTable">
                  <thead>
                    <tr>
                      <th scope="col">S.No</th>
                      <th scope="col">Item</th>
                      <th scope="col">Quantity</th>
                      <th scope="col">Unit Rate</th>
                      <th scope="col">Amount (INR)</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.prescriptionData[0].medicines.map(
                      (val, index) => {
                        return (
                          <tr className="prescriptionRow">
                            <td>{index + 1}</td>
                            <td>{val.medicine}</td>
                            <td>{val.quantity != null ? val.quantity : "0"}</td>
                            <td>
                              {val.unit_rate != null ? val.unit_rate : "0"}
                            </td>
                            <td>{val.amount != null ? val.amount : "0"}</td>
                            <td
                              className={
                                this.props.isFrom === "cancelledDashboard"
                                  ? "text-danger"
                                  : val.is_active === 1
                                  ? "text-success"
                                  : "text-danger"
                              }
                            >
                              {this.props.isFrom === "cancelledDashboard"
                                ? "Cancelled"
                                : val.is_active === 1
                                ? "Approved"
                                : "Deleted"}
                            </td>
                          </tr>
                        );
                      }
                    )}
                  </tbody>
                </table>
              )}
            </div>

            {this.state.totalAmt != null && (
              <div className="pres_modalamt">
                <div className="pres_modalamtdiv">
                  <p>
                    {this.props.isFrom === "cancelledDashboard"
                      ? "Total"
                      : "Approved"} &nbsp;:&nbsp;
                  </p>
                  
                  <p>{this.state.totalAmt + " INR"}</p>
                </div>
              </div>
            )}
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

export default PerscriptionModal;
